var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "joinStart"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "logoContent"
  }, [_c('svg', {
    staticClass: "commonLogo",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": _vm.logoSvg
    }
  })]), _c('span', {
    staticClass: "logoText"
  }, [_vm._v(_vm._s(_vm.State.logoTitle))])]), _c('div', {
    staticClass: "noLoginLang"
  }, [_c('div', {
    staticClass: "pointer common",
    on: {
      "click": function ($event) {
        return _vm.setTheme(!_vm.isDark ? 'dark' : 'light');
      }
    }
  }, [_c('span', {
    staticClass: "theme"
  }, [!_vm.isDark ? _c('i', {
    staticClass: "iconfont icon-Frame2"
  }) : _c('i', {
    staticClass: "iconfont icon-a-Frame11"
  })]), _c('span', {
    staticClass: "fontTheme"
  }, [!_vm.isDark ? _c('span', [_vm._v(_vm._s(_vm.$t('common.light')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('common.dark')))])])]), _c('div', {
    staticClass: "pointer common",
    on: {
      "click": _vm.changeParticipantLanguage
    }
  }, [_c('span', {
    staticClass: "iconLang"
  }, [_vm.$i18n.locale === 'zh' ? _c('i', {
    staticClass: "iconfont icon-a-V2chinese"
  }) : _c('i', {
    staticClass: "iconfont icon-a-V2English"
  })]), _c('span', {
    staticClass: "fontLang"
  }, [_vm.$i18n.locale === 'zh' ? _c('p', [_vm._v("中文")]) : _c('p', [_vm._v("English")])])])])]), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "head"
  }, [_vm._v(_vm._s(_vm.$t('start.startHead')))]), _c('p', {
    staticClass: "info"
  }, [_vm._v(_vm._s(_vm.$t('start.startText')))]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.showJoinParty,
      expression: "!showJoinParty"
    }],
    staticClass: "foot"
  }, [_c('el-button', {
    staticClass: "startParty",
    on: {
      "click": _vm.login
    }
  }, [_c('i', {
    staticClass: "iconfont icon-startParty"
  }), _vm._v(" " + _vm._s(_vm.$t('start.getStarted')) + " ")]), _c('el-button', {
    staticClass: "joinParty green noBg",
    on: {
      "click": _vm.showJoin
    }
  }, [_c('i', {
    staticClass: "iconfont icon-joinParty"
  }), _vm._v(" " + _vm._s(_vm.$t('start.joinParty')) + " ")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showJoinParty,
      expression: "showJoinParty"
    }],
    staticClass: "joinFoot"
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "popper-class": "joinInput",
      "fetch-suggestions": _vm.getHistoryList,
      "placeholder": _vm.$t('start.joinPlaceholder')
    },
    nativeOn: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.joinParty.apply(null, arguments);
      }
    },
    model: {
      value: _vm.joinInfo,
      callback: function ($$v) {
        _vm.joinInfo = $$v;
      },
      expression: "joinInfo"
    }
  }), _c('el-button', {
    staticClass: "joinBtn",
    class: {
      green: _vm.joinInfo
    },
    attrs: {
      "disabled": !_vm.joinInfo,
      "size": "small"
    },
    on: {
      "click": _vm.joinParty
    }
  }, [_vm._v(_vm._s(_vm.$t('start.join')))]), _c('el-button', {
    staticClass: "cancelBtn",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.$t('start.cancel')))])], 1), _c('el-divider', {
    staticClass: "leftDivider"
  }), _c('p', {
    staticClass: "learnMore"
  }, [_c('a', {
    staticClass: "greenColor",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "https://www.tvunetworks.com/products/tvu-partyline/",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('start.learnMore')))]), _vm._v(_vm._s(_vm.$t('start.learnMoreNext')))])], 1), _c('div', {
    staticClass: "contentRight"
  }, [_c('rorartionChart', {
    attrs: {
      "isDark": _vm.isDark
    }
  })], 1)])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };